import { useContext, useEffect } from 'react';

import { AuthContext } from '../../globalContext/auth/authProvider';
import { ThemeContext } from '../../globalContext/theme/themeProvider';
import { toggleColorMode } from '../../globalContext/theme/themeActions';
import {
  applyBrandTheme,
  resolveAuthenticatedBrandKey,
  resolveBrandKey,
} from '../../theme/brands';

/**
 * Keeps MUI brand theme in sync with auth state and login URL.
 * buId reconciliation runs in withPrivateAccess when USER_INFO returns.
 */
const BrandThemeSync = () => {
  const [authState] = useContext(AuthContext);
  const [, themeDispatch] = useContext(ThemeContext);

  useEffect(() => {
    const brandKey = authState?.token
      ? resolveAuthenticatedBrandKey()
      : resolveBrandKey();

    const config = applyBrandTheme(brandKey);
    themeDispatch(toggleColorMode({ brand: config }));
  }, [authState?.token, themeDispatch]);

  return null;
};

export default BrandThemeSync;
